// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12IIj","top":"styles_top__1tKiL","left":"styles_left__3oMkI","description":"styles_description__rI5NF"};